import { connect } from 'react-redux'
import Routes from './routes'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => ({
  showMembership: me.account.policy.can_see_subscriptions,
  isParent: me.account.role_in_life === 'parent'
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(Routes)
)
